import { useNavigate } from "react-router-dom";

import { isAndroidPlatform, isIosPlatform } from "@/utils/platform.helpers";

import { AndroidPushNotificationActionPerformedData } from "../AndroidPushNotificationAdapter/AndroidPushNotificationAdapter";
import { IOSPushNotificationActionPerformedData } from "../IOSPushNotificationAdapter/IOSPushNotificationAdapter";
import { PushNotificationActionPerformed } from "../IPushNotificationAdapter";

export const useDeepLinkNavigation = () => {
  const navigate = useNavigate();

  const handleNotificationAction = (
    actionPerformed: PushNotificationActionPerformed<
      | AndroidPushNotificationActionPerformedData
      | IOSPushNotificationActionPerformedData
    >
  ) => {
    const { notification } = actionPerformed;

    console.log("[RMD]: handleNotificationAction", actionPerformed);

    let url;

    if (isAndroidPlatform()) {
      url = (notification as AndroidPushNotificationActionPerformedData).data
        ?.dataUrl;
    }

    if (isIosPlatform()) {
      url = (notification as IOSPushNotificationActionPerformedData).data?.aps
        ?.alert?.dataUrl;
    }

    if (!url) {
      return;
    }

    if (isInternalAppRoute(url)) {
      navigate(url);
    } else {
      console.log(
        "[RMD]: Ignoring external or API URL from notification:",
        url
      );
    }
  };

  return { handleNotificationAction };
};

function isInternalAppRoute(url: string): boolean {
  if (url.includes("://")) return false;

  if (url.startsWith("/api/")) return false;

  return true;
}
